/**
 * @fileOverview This component is specific for US and CA markets to load
 * market specific terms and conditions.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { isUS } from '@americanexpress/axp-manage-bookings-utils/build/utilities/helpers';
import { useFetchye } from 'fetchye';
import { useReactlytics } from '@americanexpress/reactlytics';
import { sanitizeHtml } from '@americanexpress/axp-manage-bookings-utils';
import { Link } from '@americanexpress/dls-react';
import styles from './styles.scss';

import Spinner from '../Spinner/Spinner';

export const USandCATnC = () => {
  const intl = useIntl();
  const analytics = useReactlytics();
  const { isLoading, data } = useFetchye(intl?.messages?.links?.termsLink);

  if (isLoading) {
    return <Spinner label="US and CA Terms Progress Bar" />;
  }

  const handleAnalytics = () => {
    analytics.track({
      event: {
        element: 'sellerOfTravel',
        type: 'click',
        timestamp: new Date().toISOString(),
      },
    });
  };

  return (
    <div className={`card ${styles.tncFooter}`}>
      {data?.body?.tnc?.map((tncTerms, index) => (
        <div className="container" key={tncTerms.header}>
          {tncTerms.header && (
            <h3 className="margin-1-b heading-2">{tncTerms.header}</h3>
          )}
          <p className="margin-1-tb">
            {sanitizeHtml(tncTerms.bodyTextBeforeLink)}
            {tncTerms.linkText && (
              <Link
                id={`TravelTermsLink${index}`}
                className={styles.linkDecoration}
                href={intl.messages.links[tncTerms.program]}
                target="_blank"
                onClick={() => handleAnalytics()}
              >
                {' '}
                {tncTerms.linkText}
              </Link>
            )}
            {sanitizeHtml(tncTerms.bodyTextAfterLink)}
          </p>
          {isUS(intl.locale) && (
            <p>{sanitizeHtml(tncTerms.bodyAdditionalInfoText)}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default USandCATnC;
